<div style="margin: 10px;">

  <legend style="margin-left: 15px;">Select Protocols/Credentials to Be Used During Discovery</legend>

  <div class="col-lg-8" style="margin-top: 20px;">
    <p-table [value]="ProtocolSettingsData" [scrollable]="true" scrollHeight="500px"
      [resizableColumns]="true">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn class="uv-table-checkbox">
            <input type="checkbox" [checked]="SelectAllState" (change)="SelectAllChanged($event)" />
          </th>
          <th pResizableColumn>Name</th>
          <th pResizableColumn [ngStyle]="{'width':'200px'}">Protocol Type</th>
          <th pResizableColumn [ngStyle]="{'width':'200px'}">Use Count</th>
          <th pResizableColumn [ngStyle]="{'width':'200px'}"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td class="uv-table-checkbox">
            <input type="checkbox" [checked]="rowData.Selected" (change)="SettingsSelectionChanged($event, rowData)" />
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.Name }}</span>
          </td>
          <td [ngStyle]="{'width':'200px'}">
            <span class="uv-table-value">{{ rowData.ProtocolType }}</span>
          </td>
          <td [ngStyle]="{'width':'200px'}">
            <span class="uv-table-value">{{ rowData.UseCount }}</span>
          </td>
          <td [ngStyle]="{'width':'200px'}">
            <a [ngClass]="{'disabled': !CanMoveUp(rowData)}" (click)="MoveUp(rowData)" class="btn"
              style="font-size: 14px;">
              <i class="fa fa-arrow-up"></i>
              Up
            </a>
            <a [ngClass]="{'disabled': !CanMoveDown(rowData)}" (click)="MoveDown(rowData)" class="btn"
              style="font-size: 14px;">
              <i class="fa fa-arrow-down"></i>
              Down
            </a>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <br />
  </div>

  <form [formGroup]="SettingsForm" style="margin-left: 15px;">
    <fieldset>
      <legend>Command-Line Interface (CLI) Settings</legend>
      <div style="margin-top: 10px;">
        <input type="checkbox" [formControl]="EnableCliDiscovery" />
        <span class="uv-checkbox-label">Enable CLI (SSH/TELNET) Discovery</span>
      </div>
    </fieldset>
    <fieldset style="margin-top: 20px;">
      <legend>Windows Inventory Settings</legend>
      <div>
        <input type="radio" name="winInvType" value="false" [formControl]="FullWindowsInventory" />
        <span class="uv-checkbox-label">Collect Basic Windows Inventory (System, OS, BIOS, etc.)</span>
        <br>
          <input type="radio" name="winInvType" value="true" [formControl]="FullWindowsInventory" />
          <span class="uv-checkbox-label">Collect Full Windows Inventory (Basic + Installed Software, Software Updates, etc.)</span>
          <br>
          </div>
          @if (FullWindowsInventory.hasError('required')) {
            <div class="alert alert-danger">This value is required</div>
          }
        </fieldset>
      </form>
    </div>
